const AccessibleText = ({
	children,
	role = null,
	ariaLevel = null,
	ariaLive = null,
}) => {
	return (
		<span
			role={role}
			aria-level={ariaLevel}
			aria-live={ariaLive}
			className="help-accessible-text"
		>
			{children}
		</span>
	);
};

export default AccessibleText;
